import TrailerSelectorDialog from "../../../../../../dialogs/selectors/TrailerSelectorDialog";

const TradoEditorTrailerDialogs = ({
  showTrailerBerangkatSelector,
  setShowTrailerBerangkatSelector,
  handleOnConfirmTrailerBerangkat,
  showTrailerPulangSelector,
  setShowTrailerPulangSelector,
  handleOnConfirmTrailerPulang,
}) => {
  return (
    <>
      <TrailerSelectorDialog
        title="Pilih Trailer Berangkat"
        visible={showTrailerBerangkatSelector}
        onHide={() => setShowTrailerBerangkatSelector(false)}
        onConfirm={handleOnConfirmTrailerBerangkat}
      />

      <TrailerSelectorDialog
        title="Pilih Trailer Pulang"
        visible={showTrailerPulangSelector}
        onHide={() => setShowTrailerPulangSelector(false)}
        onConfirm={handleOnConfirmTrailerPulang}
      />
    </>
  );
};

export default TradoEditorTrailerDialogs;
